import * as React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import classnames from 'classnames';
import {
    withStyles, Typography, Avatar,
} from '@material-ui/core';

import { getElementTitle } from '../../../youwell-common/contentUtils';
import HtmlContent from '../../../youwell-common/components/HtmlContent';
import { getTaskColorByName } from '../../../common/utils/programUtils';

const styles = theme => ({
    root: {
        display: 'flex',

        [theme.breakpoints.down('xs')]: {
            flexDirection: 'column',
        },
    },
    aboutColumn: {
        flex: '1 1 25%',
        margin: theme.spacing(1),
        display: 'flex',
        flexDirection: 'column',
    },
    aboutColumnHeader: {
        background: theme.colors.blue4,
        color: theme.palette.common.white,
        padding: theme.spacing(1),
    },
    aboutTaskBox: {
        marginTop: theme.spacing(1),
        background: theme.colors.grey2,
        padding: theme.spacing(1),
        display: 'flex',
        flexDirection: 'column',
    },
    main: {
        flex: '1 1 auto',
        padding: theme.spacing(1),
        marginBottom: theme.spacing(1),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        marginBottom: theme.spacing(2),
    },
    content: {
        textAlign: 'center',
        color: theme.colors.blue4,
    },
});


const Box = ({ classes, title, content }) => (
    <div className={classes.aboutTaskBox}>
        <div className={classes.main}>
            <Avatar className={classes.avatar} style={{ background: getTaskColorByName(title) }}>{title.slice(0, 1)}</Avatar>
            <HtmlContent html={content} className={classes.content} />
        </div>
    </div>
);

Box.propTypes = {
    classes: PropTypes.object.isRequired,
    title: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
};


class AboutTheExercises extends React.Component {
    render() {
        const {
            classes, className, overviewModule,
        } = this.props;

        return (
            <div className={classnames(classes.root, className)}>
                {overviewModule?.tasks?.map(task => (
                    <div key={task.id} className={classes.aboutColumn}>
                        <Typography variant="h6" color="inherit" className={classes.aboutColumnHeader}>
                            {task.name}
                        </Typography>
                        {task.contentElements?.map(element => (
                            <Box
                                key={element.id}
                                classes={classes}
                                title={getElementTitle(element)}
                                content={element.htmlContent}
                            />
                        ))}
                    </div>
                ))}
            </div>
        );
    }
}

AboutTheExercises.propTypes = {
    classes: PropTypes.object.isRequired,
    overviewModule: PropTypes.object,
    className: PropTypes.string,
};

AboutTheExercises.defaultProps = {
    className: null,
    overviewModule: null,
};

const mapStateToProps = state => ({
    translate: getTranslate(state.localize),
    overviewModule: state.program.content && state.program.content[state.pageSettings.appConfig?.contentProgramId]?.modules?.find(d => d.id === state.pageSettings.appConfig?.teachingShortModuleId),
});

export default connect(mapStateToProps)(withStyles(styles)(AboutTheExercises));
